export default function GGHero() {
  return (
    <section className="relative overflow-hidden" style={{ background: "linear-gradient(135deg, #0f2460 0%, #1a3a8a 50%, #0e4a7a 100%)", minHeight: 560 }}>
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=government%20smart%20city%20grid%20management%20system%2C%20aerial%20view%20of%20urban%20district%20with%20digital%20overlay%2C%20administrative%20zones%20visualization%2C%20satellite%20imagery%20with%20network%20grid%20lines%2C%20deep%20purple%20and%20gold%20technology%20aesthetic&width=1440&height=520&seq=gg-hero-1&orientation=landscape"
          alt="政务网格管理背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f2460]/90 via-[#0f2460]/60 to-transparent"></div>
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "linear-gradient(rgba(100,200,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(100,200,255,0.3) 1px, transparent 1px)", backgroundSize: "48px 48px" }}>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 pt-20 pb-24 flex items-center gap-14">
        {/* Left */}
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 bg-cyan-400/10 border border-cyan-400/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-government-line text-cyan-300 text-sm"></i>
            <span className="text-cyan-300 text-xs font-medium tracking-wide">数字政务 · 网格治理 · 精细管理</span>
          </div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-3">
            政务网格管理
            <span className="block text-xl font-normal text-cyan-300 mt-2">Government Grid Management Platform</span>
          </h1>
          <p className="text-blue-100/80 text-sm leading-relaxed mb-6 max-w-lg">
            覆盖网格台账、民生看板、设施分布、隐患标注与事件闭环全流程，为街道办、基层派出所与管委会提供一体化数字化治理平台，实现精细化城市管理。
          </p>

          {/* 5 key features */}
          <div className="flex flex-wrap gap-2 mb-8">
            {["网格台账", "民生看板", "设施分布", "隐患标注", "事件闭环"].map((f) => (
              <span key={f} className="flex items-center gap-1.5 bg-white/10 border border-white/20 text-white/90 text-xs px-3 py-1.5 rounded-full">
                <i className="ri-checkbox-circle-line text-cyan-300 text-xs"></i>
                {f}
              </span>
            ))}
          </div>

          {/* Target customers */}
          <div className="flex items-center gap-2 mb-8">
            <span className="text-white/50 text-xs">面向客户：</span>
            {["街道办事处", "基层派出所", "管委会", "社区服务中心"].map((c) => (
              <span key={c} className="text-xs bg-cyan-400/15 border border-cyan-400/25 text-cyan-200 px-2.5 py-1 rounded-md">{c}</span>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button className="bg-cyan-400 hover:bg-cyan-300 text-[#0f2460] font-semibold px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">
              申请试点方案
            </button>
            <button className="border border-white/30 hover:border-white/60 text-white px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-download-line"></i>产品白皮书
            </button>
          </div>
          <div className="flex items-center gap-8 mt-8">
            {[["300+", "政务客户"], ["98.7%", "事件处置率"], ["4.2h", "平均响应时效"]].map(([val, label]) => (
              <div key={label}>
                <div className="text-2xl font-bold text-cyan-300">{val}</div>
                <div className="text-blue-200/60 text-xs mt-0.5">{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Map product screenshot */}
        <div className="flex-shrink-0 w-[460px]">
          <div className="bg-[#0a1a3a]/80 backdrop-blur-sm border border-white/15 rounded-2xl overflow-hidden">
            {/* App bar */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-white/5">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-rose-400"></div>
                <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-white/60 text-xs">政务网格管理平台 · XX街道网格总览</span>
              <span className="text-cyan-300 text-xs bg-cyan-400/10 px-2 py-0.5 rounded-full">实时监控</span>
            </div>
            {/* Map area */}
            <div className="relative">
              <img
                src="https://storage.readdy-site.link/project_files/02def1b9-d9c4-48b0-8b26-78725c402107/e934a52e-72cf-466a-b2b0-cfd5771771b5_unnamed.png?v=429da2925157f145ba446cb48b4a483b"
                alt="网格管理面板"
                className="w-full h-52 object-cover object-top"
              />
              {/* Overlay badges */}
              <div className="absolute top-3 left-3 bg-[#0a1a3a]/90 border border-white/15 rounded-lg px-3 py-2">
                <div className="text-xs text-white/60 mb-0.5">网格总数</div>
                <div className="text-lg font-bold text-cyan-300">128 格</div>
              </div>
              <div className="absolute top-3 right-3 bg-[#0a1a3a]/90 border border-rose-400/30 rounded-lg px-3 py-2">
                <div className="text-xs text-rose-300 font-semibold">待处置隐患</div>
                <div className="text-base font-bold text-rose-300">7 处</div>
              </div>
              {/* Status tags */}
              <div className="absolute bottom-3 left-3 flex gap-2">
                {[["正常", "text-emerald-300 bg-emerald-400/20"], ["预警", "text-amber-300 bg-amber-400/20"], ["紧急", "text-rose-300 bg-rose-400/20"]].map(([t, c]) => (
                  <span key={t} className={`text-xs border border-white/20 px-2.5 py-1 rounded-full ${c}`}>{t}</span>
                ))}
              </div>
            </div>
            {/* Bottom stats */}
            <div className="grid grid-cols-4 gap-0 border-t border-white/10">
              {[["待处理事件", "23", "text-cyan-300"], ["处置中", "8", "text-blue-300"], ["今日完成", "156", "text-emerald-300"], ["安全隐患", "7", "text-rose-300"]].map(([label, val, color]) => (
                <div key={label} className="px-3 py-3 text-center border-r border-white/10 last:border-0">
                  <div className={`text-sm font-bold ${color}`}>{val}</div>
                  <div className="text-white/40 text-xs mt-0.5">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}